import { render, staticRenderFns } from "./ResetTransactions.vue?vue&type=template&id=504549eb&scoped=true"
import script from "./ResetTransactions.vue?vue&type=script&lang=js"
export * from "./ResetTransactions.vue?vue&type=script&lang=js"
import style0 from "./ResetTransactions.vue?vue&type=style&index=0&id=504549eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504549eb",
  null
  
)

export default component.exports